module.exports = __webpack_public_path__ + "static/media/rainNight.c0479ce3.png";